<template>
  <v-dialog v-model="newUserDialog" max-width="500px" persistent scrollable>
    <v-card>
      <v-toolbar dark>
        <v-toolbar-title class="headline">New User</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog', false)">close</v-icon>
      </v-toolbar>
      <v-card-text style="height: auto">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row>
            <v-flex xs2 class="mr-2">
              <v-select
                :items="country_tel"
                v-model="user_country_tel"
                label="Select"
              ></v-select>
            </v-flex>
            <v-flex xs10 class="ml-2">
              <v-text-field
                v-model="tel"
                mask="## - ### - ####"
                label="Tel."
                :rules="[telValid.leng, telValid.required, telValid.already]"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs6 class="mr-2">
              <v-text-field
                v-model="fname"
                label="First name"
                :rules="[nameValid.max, nameValid.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 class="ml-2">
              <v-text-field
                v-model="lname"
                label="Last name"
                :rules="[nameValid.max, nameValid.required]"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-flex xs12>
            <v-text-field
              v-model="email"
              label="Email"
              :rules="[
                emailValid.email,
                emailValid.required,
                emailValid.already,
                nameValid.max,
              ]"
            ></v-text-field>
            <v-select
              :items="RoleItems"
              item-text="name"
              item-value="value"
              v-model="role"
              label="Role"
              :rules="[roleValid.required]"
            ></v-select>
            <v-layout row>
              <v-flex xs6>
                <v-radio-group v-model="user_province_type">
                  <v-radio :label="'All'" :value="1"></v-radio>
                  <v-radio :label="'Select province'" :value="2"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  v-model="user_province"
                  :items="province_list"
                  outlined
                  name="province"
                  :loading="loadingProvince"
                  item-text="province_name_en"
                  item-value="province_name_en"
                  dense
                  chips
                  small-chips
                  label="Select province"
                  multiple
                  v-if="user_province_type == 2"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <div class="line-newpass"></div>
            <v-text-field
              v-model="password1"
              :append-icon="show1 ? 'visibility_off' : 'visibility'"
              :type="show1 ? 'text' : 'password'"
              label="Password"
              autocomplete="new-password"
              hint="At least 6 characters"
              class="input-group--focused"
              @click:append="show1 = !show1"
              :rules="[passwordValid.min, passwordValid.max]"
            ></v-text-field>
            <v-text-field
              v-model="password2"
              :append-icon="show2 ? 'visibility_off' : 'visibility'"
              :type="show2 ? 'text' : 'password'"
              autocomplete="new-password"
              label="Confirm Password"
              hint="At least 6 characters"
              class="input-group--focused"
              @click:append="show2 = !show2"
              :rules="[passwordValid.min, passwordValid.max]"
            ></v-text-field>
          </v-flex>
          <div v-if="passwordMatch == false">Password Not match ...</div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" flat @click="$emit('setDialog', false) && clear()"
          >Cancel</v-btn
        >
        <v-btn
          color="green"
          flat
          :disabled="isEditStaff"
          @click="addUser() && clear()"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: ["newUserDialog"],
  data() {
    return {
      user_province_type: 1,
      loadingProvince: false,
      user_province: [],
      user_country_tel: "+66",
      country_tel: ["+66"],
      passwordMatch: true,
      RoleItems: [
        {
          name: "SuperAdmin",
          value: 1,
        },
        {
          name: "Admin",
          value: 2,
        },
        {
          name: "Viewer(Manager)",
          value: 3,
        },
        {
          name: "Callcenter",
          value: 4,
        },
        {
          name: "Customer",
          value: 6,
        },
        {
          name: "RiderManager",
          value: 8,
        },
        {
          name: "Accounting",
          value: 9,
        },
        {
          name: "Marketing",
          value: 10,
        },
        {
          name: "AdminLaborStore",
          value: 11,
        },
      ],
      password1: "",
      password2: "",
      show1: false,
      show2: false,
      tel: "",
      verify: "",
      email: "",
      fname: "",
      lname: "",
      role: 1,
      valid: true,
      telValid: {
        required: (value) => !!value || "Required.",
        leng: (v) => v.length == 9 || "9 characters",
        already: (a) => !this.telAlready(a) || "Already in use",
      },
      nameValid: {
        required: (value) => !!value || "Required.",
        max: (v) => v.length <= 55 || "Min 55 characters",
      },
      emailValid: {
        already: (a) => !this.emailAlready(a) || "Already in use",
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      roleValid: {
        required: (value) => !!value || "Required.",
      },
      passwordValid: {
        min: (v) => v.length >= 6 || "At least 6 characters",
        max: (v) => v.length <= 24 || "No more than 24 characters",
      },
    };
  },
  watch: {
    async newUserDialog() {
      if (this.newUserDialog == true) {
        this.loadingProvince = true;
        await this.$store.dispatch("fetchProvinceBack/getData");
        this.loadingProvince = false;
      } else {
        this.clear();
      }
    },
    password1() {
      if (this.password1.length > 5 && this.password1.length < 25) {
        if (this.password1 != this.password2) {
          this.passwordMatch = false;
        } else {
          this.passwordMatch = true;
        }
      } else {
        this.passwordMatch = true;
      }
    },
    password2() {
      if (this.password2.length > 5 && this.password2.length < 25) {
        if (this.password1 != this.password2) {
          this.passwordMatch = false;
        } else {
          this.passwordMatch = true;
        }
      } else {
        this.passwordMatch = true;
      }
    },
  },
  computed: {
    ...mapState({
      userData: (state) => state.fetchUserBack.userData,
    }),
    ...mapGetters({
      isEditStaff: "isEditStaff",
      province_list: "fetchProvinceBack/provinceSplited",
    }),
  },
  methods: {
    telAlready(a) {
      let check = 0;
      for (let key in this.userData) {
        if (a == this.userData[key].user_tel) {
          check = 1;
        }
      }
      if (check == 0) {
        return false;
      } else {
        return true;
      }
    },
    emailAlready(a) {
      let check = 0;
      for (let key in this.userData) {
        if (a == this.userData[key].user_email) {
          check = 1;
        }
      }
      if (check == 0) {
        return false;
      } else {
        return true;
      }
    },
    async addUser() {
      if (this.$refs.form.validate()) {
        if (this.password1.length > 5 && this.password1.length < 25) {
          if (this.passwordMatch == true) {
            let userInfo = {
              user_country_tel: "+66",
              user_tel: this.tel,
              user_type: 1,
              user_email: this.email,
              user_password: this.password2,
              user_first_name: this.fname,
              user_last_name: this.lname,
              user_province: this.user_province,
              user_role: this.role,
            };
            if (this.user_province_type == 1) {
              userInfo.user_province = ["all"];
            }
            let result = await this.$store.dispatch(
              "fetchUserBack/addUser",
              userInfo
            );
            if (result === true) {
              this.$emit("setDialog", false);
              this.clear();
              this.password1 = "";
              this.password2 = "";
            } else {
              alert("เบอร์โทรศัพท์ซ้ำหรือมีบางอย่างผิดพลาด");
            }
          }
        }
      }
    },
    clear() {
      this.user_province = [];
      this.user_province_type = 1;
      this.tel = "";
      this.email = "";
      this.fname = "";
      this.lname = "";
      this.role = 1;
      this.password1 = "";
      this.password2 = "";
      this.$refs.form.resetValidation();
    },
  },
};
</script>

<style>
.line-newpass {
  overflow: visible;
  padding: 0;
  border: none;
  border-top: 2px solid black;
  color: #333;
  text-align: center;
  margin-top: 25px;
}

.line-newpass:after {
  content: "Set Password";
  display: inline-block;
  position: relative;
  top: -0.8em;
  font-size: 17px;
  padding: 0 0.25em;
  background: white;
}
</style>
